namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    
    export class CancellationController {
        
        public cmd: CancelTasksCommand = new CancelTasksCommand();
        
        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
                private minhasTarefasService: MinhasTarefasService,
                private tarefasCacheService: TarefasCacheService,
                private tasks: ITask[]) { 
           this.cmd.addTasks(tasks);
        }

        public cancelTasks(): void {
            this.minhasTarefasService.cancelTasks(this.cmd)
                .then(() => {
                    this.tasks.forEach(task => this.tarefasCacheService.remove(task));
                    this.$mdDialog.hide();
                });
        }
        
        public closeDialog(): void {
            this.$mdDialog.hide();
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.CancellationController", CancellationController);
}